(function () {
  const ritualVideo = document.querySelector('.buddy-skin-advertorial__ritual-video');
  if (ritualVideo) {
    const firstClipEnd = 5.45;
    let playbackRequested = false;

    const playFirstClip = () => {
      ritualVideo.muted = true;
      const playAttempt = ritualVideo.play();

      if (playAttempt?.then) {
        playAttempt
          .then(() => {
            playbackRequested = true;
            ritualVideo.controls = false;
          })
          .catch(() => {
            playbackRequested = false;
            ritualVideo.controls = true;
          });
      }
    };

    const restartFirstClip = () => {
      ritualVideo.currentTime = 0;
      playFirstClip();
    };

    ritualVideo.addEventListener('timeupdate', () => {
      if (ritualVideo.currentTime >= firstClipEnd) restartFirstClip();
    });
    ritualVideo.addEventListener('ended', restartFirstClip);

    if ('IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !playbackRequested) playFirstClip();
          });
        },
        { threshold: 0.35 }
      );

      videoObserver.observe(ritualVideo);
    } else {
      playFirstClip();
    }

    ritualVideo.addEventListener('canplay', playFirstClip, { once: true });
    window.addEventListener('pageshow', playFirstClip);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden && ritualVideo.getBoundingClientRect().top < window.innerHeight) playFirstClip();
    });
  }

  const journey = document.querySelector('[data-advertorial-scroll-journey]');
  const startAnchor = document.querySelector('[data-advertorial-journey-start]');
  const stages = Array.from(document.querySelectorAll('[data-advertorial-journey-stage]'));
  const productIntro = document.querySelector('[data-advertorial-product-intro]');
  if (!journey || !startAnchor || !stages.length || !productIntro) return;

  // Keep the original photo in place when the interactive comparison floats.
  const beforeImage = journey.querySelector('.buddy-skin-advertorial__journey-layer--before img');
  if (beforeImage && !startAnchor.querySelector('.buddy-skin-advertorial__journey-background')) {
    const background = document.createElement('div');
    background.className = 'buddy-skin-advertorial__journey-background buddy-skin-advertorial__journey-layer--before';
    background.setAttribute('aria-hidden', 'true');
    const image = beforeImage.cloneNode(false);
    image.alt = '';
    image.removeAttribute('fetchpriority');
    background.appendChild(image);
    startAnchor.prepend(background);
  }

  const manualSlider = journey.querySelector('[data-advertorial-journey-manual]');
  const advertorial = journey.closest('[data-advertorial-section]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let ticking = false;
  let dismissed = false;
  let ctaUnlocked = false;

  try {
    dismissed = window.sessionStorage.getItem('buddySkinJourneyDismissedV2') === 'true';
  } catch (error) {
    dismissed = false;
  }

  const setDismissed = () => {
    dismissed = true;
    journey.classList.remove('is-active');
    journey.classList.add('is-dismissed');
    journey.style.setProperty('--journey-progress', `${manualSlider.value}%`);
    try {
      window.sessionStorage.setItem('buddySkinJourneyDismissedV2', 'true');
    } catch (error) {}
  };

  if (dismissed) setDismissed();

  journey.addEventListener('buddy:journey-dismiss', setDismissed);
  manualSlider?.addEventListener('input', () => {
    journey.style.setProperty('--journey-progress', `${manualSlider.value}%`);
  });

  if (!document.documentElement.hasAttribute('data-buddy-skin-journey-dismiss-handler')) {
    document.documentElement.setAttribute('data-buddy-skin-journey-dismiss-handler', 'true');
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-advertorial-journey-close]');
      if (!button) return;
      const currentJourney = button.closest('[data-advertorial-scroll-journey]');
      if (!currentJourney) return;
      currentJourney.classList.remove('is-active');
      currentJourney.classList.add('is-dismissed');
      currentJourney.dispatchEvent(new CustomEvent('buddy:journey-dismiss'));
    });
  }

  const updateStickyCtaGate = (viewportMarker) => {
    if (!advertorial) return;
    const shouldUnlock = productIntro.getBoundingClientRect().bottom <= viewportMarker;
    if (shouldUnlock === ctaUnlocked) return;

    ctaUnlocked = shouldUnlock;
    if (ctaUnlocked) {
      advertorial.removeAttribute('data-hide-buy-now-modal');
    } else {
      advertorial.setAttribute('data-hide-buy-now-modal', 'true');
    }

    window.BuddyBuyNowModalController?.refreshObservers?.();
  };

  const update = () => {
    const viewportMarker = window.innerHeight * 0.42;
    updateStickyCtaGate(viewportMarker);

    if (dismissed) {
      journey.classList.remove('is-active');
      ticking = false;
      return;
    }

    const heroBounds = startAnchor.getBoundingClientRect();
    const journeyStart = window.scrollY + heroBounds.top + heroBounds.height * 0.5;
    const header = document.querySelector('.shopify-section-header');
    const pinOffset = Math.max(0, header?.getBoundingClientRect().bottom || 0);
    const end = productIntro.getBoundingClientRect().top;
    const isActive = window.scrollY + pinOffset >= journeyStart && end > viewportMarker;
    journey.classList.toggle('is-active', isActive);

    if (!isActive) {
      ticking = false;
      return;
    }

    let nextIndex = 0;
    stages.forEach((stage, index) => {
      if (stage.getBoundingClientRect().top <= viewportMarker) nextIndex = index;
    });

    const journeyEnd = window.scrollY + end;
    const distance = Math.max(1, journeyEnd - journeyStart - viewportMarker + pinOffset);
    const progress = reducedMotion.matches
      ? nextIndex / Math.max(1, stages.length - 1)
      : Math.min(1, Math.max(0, (window.scrollY + pinOffset - journeyStart) / distance));

    journey.style.setProperty('--journey-progress', `${Math.round(progress * 1000) / 10}%`);
    manualSlider.value = String(Math.round(progress * 100));

    ticking = false;
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  reducedMotion.addEventListener?.('change', requestUpdate);
  requestUpdate();
})();
